import { ButtonComponentConfig, ButtonSize, ButtonType } from '@rappider/rappider-components/utils';

export const replyButtonConfig: ButtonComponentConfig = {
  text: 'Reply',
  size: ButtonSize.Small,
  type: ButtonType.Primary
};
